module.exports = __webpack_public_path__ + "static/media/not_buttered.fb6b035b.png";